import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'
import { $userSettings } from '@/entities/user'

export const useGetFarcanaConnection = () => {
  const [isConnected, setIsConnected] = useState(false)

  const settings = useUnit($userSettings)
  useEffect(() => {
    if (settings.farcana_jwt) {
      setIsConnected(true)
    }
  }, [settings])
  return isConnected
}
